export interface FileMetadata {
  fileName: string;
  contentType: string;
  size: number;
}
